import { StateResolver, StateResolverContext } from '../types';
import { getStepBySlug } from './steps';

/**
 * Résolveur d'état par défaut avec une logique minimale
 * Les formulaires peuvent créer leur propre resolver pour des besoins spécifiques
 */
export class DefaultStateResolver implements StateResolver {
    resolveStepFromState(
        state: string,
        context: StateResolverContext
    ): any | null {
        const { steps } = context;
        
        // Logique par défaut très basique - retourne null pour laisser
        // le comportement existant prendre le relais
        switch (state) {
            case 'new':
                return getStepBySlug('bienvenue', steps);
            default:
                return null;
        }
    }
}
